import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

import BundleProductSocialShare from "@/components/MultiFinshProductBundle/BundleProductSocialShare"
import { appendPresetToUrl, getShortenedUrlPath } from "@/utils/helper"
import {
  bundleBreadCrumbAnalytics,
  bundleBreadCrumbPrintAnalytics,
  bundleBreadCrumbShareAnalytics,
} from "@/components/MultiFinshProductBundle/analytics"

const BundleProductBreadcrumb = props => {
  const {
    staticTexts: {
      ariaLabel: { breadcrumb = "", page = "", print = "", share = "" } = {},
      home = "",
      serviceParts = "",
      priceFootnoteTitle = "",
      priceFootnote = "",
      colorFootnoteTitle = "",
      colorFootnote = "",
    },
    productCategory = "",
    homePagePath = "",
    productData = {},
    swatchUrl = "",
    imagesData = [],
    width = 0,
    presetConfigObject = {},
    productInfoBundle = [],
  } = props || {}

  const [showSocialLink, setShowSocialLink] = useState(false)
  const shareBtn = useRef(null)

  const { globalConfig } = useSelector(selectGenericState)
  const {
    general: {
      plpPagePath: plpPagePathGeneral = "",
      servicePartsLandingPath = "",
    } = {},
    plpServletPath = [],
  } = globalConfig || {}

  const plpPagePath = getShortenedUrlPath(plpPagePathGeneral ?? "/")
  const serviceLandingPath = getShortenedUrlPath(servicePartsLandingPath ?? "/")

  const getPlpCategoryUrl = () => {
    const path = plpServletPath?.find(i =>
      i.categories.includes(productCategory)
    )
    let plpUrl
    if (productCategory) {
      if (path) {
        plpUrl = `${path.url}.html`
      } else if (productCategory === "Service Parts") {
        plpUrl = `${serviceLandingPath}.html`
      } else {
        plpUrl = `${plpPagePath}/${productCategory
          .replace(/ +/g, "-")
          .toLowerCase()}.html`
      }
    } else {
      plpUrl = `${serviceLandingPath}.html`
    }

    return getShortenedUrlPath(plpUrl)
  }

  // Hide social share options when user clicks outide the options
  useEffect(() => {
    window.addEventListener("click", handleClickOutside)
    return () => window.removeEventListener("click", handleClickOutside)
  }, [])

  const handleClickOutside = e => {
    const { target } = e
    if (!shareBtn.current.contains(target)) {
      setShowSocialLink(false)
    }
  }

  const handleShareClick = () => {
    bundleBreadCrumbShareAnalytics(productInfoBundle)
    setShowSocialLink(prevProp => !prevProp)
  }

  const handleBreadCrumbAnalytics = (home, homePagePath) => {
    const categoryPath = getPlpCategoryUrl()
    const pagePath = homePagePath || categoryPath
    bundleBreadCrumbAnalytics({
      internalLinkName: home,
      link: pagePath,
      productInfoBundle,
    })
  }

  const printPDP = () => {
    const printNoteLen = document.getElementsByClassName(
      "product-detail-page__print-note"
    ).length
    if (printNoteLen === 0) {
      const printNote = `<div class='product-detail-page__print-note'><div class='container'><div class='row'><div class='col-12'><h6>${priceFootnoteTitle}</h6><p>${priceFootnote}</p><h6>${colorFootnoteTitle}</h6> <p>${colorFootnote}</p></div></div></div></div>`
      const printNoteDiv = document.createElement("div")
      printNoteDiv.innerHTML = printNote
      document.body.appendChild(printNoteDiv)
    }
    bundleBreadCrumbPrintAnalytics(productInfoBundle)
    setTimeout(() => {
      window.print()
    }, 900)
  }

  if (productData) {
    return (
      <div className="header-section kf-react-plp-container">
        <div className="product-detail-page__breadcrumb">
          <nav aria-label={breadcrumb}>
            <ol role="list" data-testid="bcm-list">
              <li role="listitem">
                <a
                  aria-label={`${home} ${page}`}
                  className="product-detail-page__breadcrumb-link"
                  href={homePagePath}
                  onClick={() => handleBreadCrumbAnalytics(home, homePagePath)}
                >
                  {` ${home}`}
                </a>
                {" / "}
              </li>
              <li role="listitem">
                <a
                  aria-label={
                    productCategory
                      ? `${productCategory} ${page}`
                      : `${serviceParts} ${page}`
                  }
                  className="product-detail-page__breadcrumb-link"
                  href={getPlpCategoryUrl()}
                  onClick={() => {
                    handleBreadCrumbAnalytics(`${home} > ${productCategory}`)
                  }}
                >
                  {productCategory ? productCategory : serviceParts}
                </a>
              </li>
            </ol>
          </nav>
        </div>
        <div className="product-detail-page__print-share-container">
          <div role="list" className="print-and-share">
            <span role="listitem">
              <button
                tabIndex="0"
                aria-label={print}
                onClick={() => printPDP()}
              >
                {" "}
                <img
                  src="/icons/print.svg"
                  alt=""
                  role="presentation"
                  width="17"
                  height="17"
                />
              </button>
            </span>
            <span role="listitem">
              <button
                tabIndex="0"
                aria-label={share}
                className="share-button"
                ref={shareBtn}
                onClick={handleShareClick}
                role="button"
                aria-haspopup
                aria-expanded={showSocialLink}
                aria-controls="print-and-share"
              >
                <img
                  src="/icons/share.svg"
                  alt=""
                  role="presentation"
                  width="17"
                  height="17"
                />
              </button>
            </span>
          </div>
          <BundleProductSocialShare
            disableInstagram
            showModal={showSocialLink}
            shareBtn={shareBtn}
            id="print-and-share"
            productInfoBundle={productInfoBundle}
            onClose={() => shareBtn?.current.focus()}
            config={globalConfig}
            asset={{
              description: productData?.ProductDescriptionProductShort_s ?? "",
              url: appendPresetToUrl(
                swatchUrl,
                imagesData[0]?.assetId,
                width,
                presetConfigObject,
                true
              ),
            }}
          />
        </div>
      </div>
    )
  }
}

export default BundleProductBreadcrumb
